import React, { Component } from 'react'
import style from './style.module.less'
import { inject, observer } from 'mobx-react'
import { getHeaderRightTextColor } from '@components/LocalMerchant/Decoration/util'

@inject('decorationStore')
@observer
export default class extends Component {
  render() {
    const {
      decorationStore: { newThemeConfig, theme },
      title,
      content,
      style: styleProp,
      contentStyle
    } = this.props

    return (
      <div className={style.header} style={{ ...styleProp }}>
        <div
          className={style.title}
          style={{ color: newThemeConfig['moduleTitle'] }}
        >
          {title}
        </div>

        <div
          className={style.content}
          style={{ ...contentStyle, color: getHeaderRightTextColor(theme) }}
        >
          {content}
        </div>
      </div>
    )
  }
}
